var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "post-drawer",
      on: {
        click: function($event) {
          if ($event.target !== $event.currentTarget) {
            return null
          }
          return _vm.close($event)
        }
      }
    },
    [
      _c("div", { staticClass: "drawer" }, [
        _c("div", { staticClass: "drawer-header" }, [
          _c("div", { staticClass: "container-title" }, [
            _c("p", { staticClass: "title" }, [_vm._v("Aperçu")]),
            _c(
              "div",
              {
                staticClass: "badge-status",
                class: _vm.event.status,
                attrs: { status: _vm.event.status }
              },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.$t("dash.post." + _vm.event.status)) +
                    "\n\n                    "
                ),
                !["awaiting_approval", "to_validate"].includes(_vm.event.status)
                  ? [
                      _vm._v(
                        "\n                    • " +
                          _vm._s(
                            new Date(_vm.event.date).toLocaleDateString(
                              "fr-FR",
                              {
                                weekday: "long",
                                day: "numeric",
                                month: "short"
                              }
                            )
                          ) +
                          "\n                    "
                      )
                    ]
                  : _vm._e()
              ],
              2
            )
          ]),
          _c(
            "div",
            { staticClass: "close" },
            [
              _c(
                "ContextMenu",
                {
                  attrs: {
                    options: [
                      {
                        label: "Copier le lien d'accès rapide",
                        name: "copyLink"
                      }
                    ],
                    id: "drawerMoreOption"
                  },
                  on: { clickOption: _vm.clickOption }
                },
                [_c("i", { staticClass: "fa-solid fa-ellipsis-vertical more" })]
              ),
              _c("i", {
                staticClass: "fa-solid fa-xmark-large",
                on: { click: _vm.close }
              })
            ],
            1
          )
        ]),
        _c(
          "div",
          {
            staticClass: "drawer-render",
            class: _vm.event.draft.tab,
            on: {
              mouseenter: function($event) {
                _vm.expandedSectionNav = false
              }
            }
          },
          [
            _c(
              "div",
              { staticClass: "container-phone" },
              [
                !_vm.currentUser.role ||
                _vm.currentUser.role.length !== 1 ||
                _vm.currentUser.role[0] !== "Viewer"
                  ? _c("div", { staticClass: "actions" }, [
                      ["scheduled", "draft"].includes(this.officialStatus)
                        ? _c("i", {
                            staticClass: "fa-solid fa-pencil",
                            on: { click: _vm.editPost }
                          })
                        : _vm._e(),
                      _c("i", {
                        staticClass: "fa-solid fa-clone",
                        on: { click: _vm.duplicatePost }
                      }),
                      _c("i", {
                        staticClass: "fa-solid fa-trash-can",
                        on: {
                          click: function() {
                            return _vm.deletePost()
                          }
                        }
                      })
                    ])
                  : _vm._e(),
                _c(
                  "Phone",
                  {
                    attrs: { showNotch: _vm.event.draft.tab == "standard" },
                    on: {
                      click: function() {
                        return (_vm.indexStorySelected =
                          (_vm.indexStorySelected + 1) %
                          Object.keys(_vm.formData.storification).length)
                      }
                    }
                  },
                  [
                    _vm.formData && Object.keys(_vm.formData).length
                      ? [
                          _vm.event.draft.tab &&
                          _vm.event.draft.tab !== "standard"
                            ? _c(
                                "div",
                                { staticClass: "drawer-container-storyMaker" },
                                [
                                  Object.keys(_vm.formData.storification)
                                    .length > 1
                                    ? _c(
                                        "div",
                                        { staticClass: "nav-story" },
                                        _vm._l(
                                          Object.keys(
                                            _vm.formData.storification
                                          ),
                                          function(key, index) {
                                            return _c("div", {
                                              staticClass: "bar",
                                              class: {
                                                active:
                                                  _vm.indexStorySelected ==
                                                  index
                                              }
                                            })
                                          }
                                        ),
                                        0
                                      )
                                    : _vm._e(),
                                  _c("StoryMaker", {
                                    attrs: {
                                      formData: _vm.formData,
                                      idStorySelected: Object.keys(
                                        _vm.formData.storification
                                      )[_vm.indexStorySelected],
                                      pageSelected:
                                        _vm.allPages[_vm.event.page.id],
                                      previewEnabled: true,
                                      files: _vm.event.draft.files
                                    }
                                  })
                                ],
                                1
                              )
                            : _c("RenderPostManager", {
                                attrs: {
                                  typeNetworkSelected: _vm.event.page.network,
                                  formData: _vm.formData,
                                  files: _vm.event.draft.files,
                                  pages: [_vm.allPages[_vm.event.page.id]]
                                }
                              })
                        ]
                      : _vm._e()
                  ],
                  2
                )
              ],
              1
            )
          ]
        ),
        _c(
          "div",
          {
            ref: "scrollContainer",
            staticClass: "drawer-container-navigation"
          },
          [
            _c(
              "div",
              {
                staticClass: "drawer-navigation",
                class: { expanded: _vm.expandedSectionNav }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "tab",
                    on: {
                      click: function($event) {
                        _vm.expandedSectionNav = !_vm.expandedSectionNav
                      }
                    }
                  },
                  [
                    _c("i", {
                      staticClass: "fa-solid",
                      class: _vm.expandedSectionNav
                        ? "fa-caret-down"
                        : "fa-caret-up"
                    }),
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "100%",
                          height: "100%",
                          viewBox: "0 0 89 20",
                          fill: "none",
                          xmlns: "http://www.w3.org/2000/svg"
                        }
                      },
                      [
                        _c("path", {
                          attrs: {
                            d:
                              "M15.0872 2C10.0401 2 5.64066 5.43527 4.41655 10.3321L2.41672 18.3321C2.2771 18.8906 2.1827 19.4477 2.13086 20H87.5309C87.495 19.6164 87.4388 19.2303 87.3613 18.8427L85.7614 10.8427C84.7332 5.70106 80.219 2 74.9759 2H15.0872Z",
                            fill: "white"
                          }
                        })
                      ]
                    )
                  ]
                ),
                _c("div", { staticClass: "navigation" }, [
                  _vm.validationStatus !== null
                    ? _c(
                        "div",
                        {
                          staticClass: "item",
                          class: {
                            active: _vm.sectionNavSelected == "validation"
                          },
                          on: {
                            click: function($event) {
                              _vm.sectionNavSelected = "validation"
                            }
                          }
                        },
                        [_vm._v("Validation")]
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    {
                      staticClass: "item",
                      class: { active: _vm.sectionNavSelected == "comments" },
                      on: {
                        click: function($event) {
                          _vm.sectionNavSelected = "comments"
                        }
                      }
                    },
                    [_vm._v("Notes")]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "item",
                      class: {
                        active: _vm.sectionNavSelected == "assignments"
                      },
                      on: {
                        click: function($event) {
                          _vm.sectionNavSelected = "assignments"
                        }
                      }
                    },
                    [_vm._v("Assignation")]
                  )
                ]),
                _vm.sectionNavSelected == "validation"
                  ? _c(
                      "div",
                      {
                        staticClass: "list-assignment hide-scrollbar",
                        class: { "no-scroll": !_vm.expandedSectionNav }
                      },
                      [
                        _vm.validationStatus
                          ? _c(
                              "div",
                              {
                                staticClass: "btn-primary",
                                class: { loading: _vm.loading.validation },
                                on: {
                                  click: function() {
                                    return _vm.removeValidationPost()
                                  }
                                }
                              },
                              [
                                _c("p", [
                                  _vm._v("Annuler la validation du post")
                                ])
                              ]
                            )
                          : _c(
                              "div",
                              {
                                staticClass: "btn-primary",
                                class: { loading: _vm.loading.validation },
                                on: {
                                  click: function() {
                                    return _vm.validatePost()
                                  }
                                }
                              },
                              [
                                _c("p", [
                                  _vm._v("Valider le post pour publication")
                                ])
                              ]
                            )
                      ]
                    )
                  : _vm.sectionNavSelected == "comments"
                  ? _c(
                      "div",
                      {
                        staticClass: "list-notes hide-scrollbar",
                        class: { "no-scroll": !_vm.expandedSectionNav }
                      },
                      [
                        _c("div", { staticClass: "item input mediaMultiple" }, [
                          _c("div", { staticClass: "container-text" }, [
                            _c("div", { staticClass: "left" }, [
                              _c("div", { staticClass: "author" }, [
                                _c("div", { staticClass: "author-picture" }, [
                                  _c("img", {
                                    attrs: {
                                      src:
                                        _vm.currentUser.avatar ||
                                        "img/avatar.jpg"
                                    }
                                  })
                                ]),
                                _vm._m(0)
                              ]),
                              _c("textarea", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.models.commentValue,
                                    expression: "models.commentValue"
                                  }
                                ],
                                ref: "textarea",
                                attrs: {
                                  rows: "1",
                                  placeholder: "Ecrivez une note..."
                                },
                                domProps: { value: _vm.models.commentValue },
                                on: {
                                  focus: _vm.resize,
                                  keyup: _vm.resize,
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.models,
                                      "commentValue",
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ]),
                            _c("div", { staticClass: "right" }, [
                              _c(
                                "div",
                                { staticClass: "container-add-media" },
                                [
                                  _vm._m(1),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "",
                                        expression: "''"
                                      }
                                    ],
                                    ref: "inputMediaComment",
                                    attrs: {
                                      name: "fileComment",
                                      type: "file",
                                      id: "fileComment",
                                      multiple: true,
                                      accept:
                                        ".jpg, .jpeg, .png, .pdf, .mp4, .webm, .ogg, .avi, .wmv, .flv, .mkv",
                                      hidden: ""
                                    },
                                    on: {
                                      change: _vm.selectFilesComment,
                                      click: function() {}
                                    }
                                  })
                                ]
                              )
                            ])
                          ]),
                          _vm.filesUploadComment.length
                            ? _c(
                                "div",
                                { staticClass: "container-media" },
                                [
                                  _vm._l(_vm.filesUploadComment, function(
                                    file,
                                    index
                                  ) {
                                    return [
                                      file.type.startsWith("image")
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "image",
                                              on: {
                                                click: function($event) {
                                                  return _vm.$delete(
                                                    _vm.filesUploadComment,
                                                    index
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("img", {
                                                attrs: { src: file.url }
                                              })
                                            ]
                                          )
                                        : file.type.startsWith("video")
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "video",
                                              on: {
                                                click: function($event) {
                                                  return _vm.$delete(
                                                    _vm.filesUploadComment,
                                                    index
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "video",
                                                {
                                                  staticClass: "source",
                                                  attrs: {
                                                    muted: "",
                                                    loop: "",
                                                    playsinline: "",
                                                    preload: "metadata",
                                                    onloadedmetadata:
                                                      "this.muted = true"
                                                  },
                                                  domProps: { muted: true }
                                                },
                                                [
                                                  _c("source", {
                                                    attrs: {
                                                      src: file.url,
                                                      type: file.type
                                                    }
                                                  })
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  })
                                ],
                                2
                              )
                            : _vm._e(),
                          _vm.models.commentValue.length ||
                          _vm.filesUploadComment.length
                            ? _c(
                                "div",
                                {
                                  staticClass: "send",
                                  class: { loading: this.loading.sendComment },
                                  on: {
                                    click: function() {
                                      return _vm.newComment()
                                    }
                                  }
                                },
                                [_c("p", [_vm._v("Envoyer")])]
                              )
                            : _vm._e()
                        ]),
                        _vm._l(_vm.comments, function(comment) {
                          return _c(
                            "div",
                            {
                              staticClass: "item",
                              class: {
                                mediaMultiple: comment.mediasUpload.length > 1
                              }
                            },
                            [
                              _c("div", { staticClass: "container-text" }, [
                                _c("div", { staticClass: "author" }, [
                                  _c("div", { staticClass: "author-picture" }, [
                                    _c("img", {
                                      attrs: {
                                        src: comment.avatar || "img/avatar.jpg"
                                      }
                                    })
                                  ]),
                                  _c(
                                    "div",
                                    { staticClass: "author-tect-info" },
                                    [
                                      _c("p", { staticClass: "name" }, [
                                        _vm._v(_vm._s(comment.name))
                                      ]),
                                      _c("p", { staticClass: "date" }, [
                                        _vm._v(_vm._s(comment.dateFormat))
                                      ])
                                    ]
                                  )
                                ]),
                                _c("p", { staticClass: "text" }, [
                                  _vm._v(_vm._s(comment.message))
                                ])
                              ]),
                              _c(
                                "div",
                                { staticClass: "container-media" },
                                [
                                  _vm._l(comment.mediasUpload, function(media) {
                                    return [
                                      media.type.startsWith("image")
                                        ? _c("div", { staticClass: "image" }, [
                                            _c("img", {
                                              attrs: { src: media.url }
                                            })
                                          ])
                                        : media.type.startsWith("video")
                                        ? _c("div", { staticClass: "video" }, [
                                            _c(
                                              "video",
                                              {
                                                staticClass: "source",
                                                attrs: {
                                                  muted: "",
                                                  loop: "",
                                                  playsinline: "",
                                                  preload: "metadata",
                                                  onloadedmetadata:
                                                    "this.muted = true"
                                                },
                                                domProps: { muted: true }
                                              },
                                              [
                                                _c("source", {
                                                  attrs: {
                                                    src: media.url,
                                                    type: media.type
                                                  }
                                                })
                                              ]
                                            )
                                          ])
                                        : _vm._e()
                                    ]
                                  })
                                ],
                                2
                              )
                            ]
                          )
                        })
                      ],
                      2
                    )
                  : _vm.sectionNavSelected == "assignments"
                  ? _c(
                      "div",
                      {
                        staticClass: "list-assignment hide-scrollbar",
                        class: { "no-scroll": !_vm.expandedSectionNav }
                      },
                      [
                        _vm._l(_vm.userAffected, function(user) {
                          return _c("div", { staticClass: "item" }, [
                            _c("div", { staticClass: "picture" }, [
                              _c("img", {
                                attrs: {
                                  src: user.avatar
                                    ? user.avatar
                                    : "img/avatar.jpg"
                                }
                              })
                            ]),
                            _c("div", { staticClass: "info-text" }, [
                              _c("div", { staticClass: "container-name" }, [
                                _c("p", { staticClass: "name" }, [
                                  _vm._v(
                                    _vm._s(user.firstname) +
                                      " " +
                                      _vm._s(user.lastname)
                                  )
                                ]),
                                _c("p", { staticClass: "role" }, [
                                  _vm._v(
                                    _vm._s(
                                      user.admin == true
                                        ? "Admin" + " "
                                        : user.role && user.role.length > 0
                                        ? _vm.$t(
                                            "dash.settings.user." + user.role[0]
                                          )
                                        : _vm.$t("dash.settings.user.Editor") +
                                          " "
                                    )
                                  )
                                ])
                              ]),
                              _c("p", { staticClass: "email" }, [
                                _vm._v(_vm._s(user.email))
                              ])
                            ]),
                            _c(
                              "div",
                              {
                                staticClass: "remove",
                                on: {
                                  click: function($event) {
                                    return _vm.removeUserAffected(user.id)
                                  }
                                }
                              },
                              [
                                _c("i", {
                                  staticClass: "fa-solid fa-xmark-large"
                                })
                              ]
                            )
                          ])
                        }),
                        _c(
                          "div",
                          {
                            staticClass: "btn-primary",
                            class: { loading: _vm.loading.setUserAffected },
                            on: { click: _vm.setUsersAffected }
                          },
                          [_c("p", [_vm._v("Assigner")])]
                        )
                      ],
                      2
                    )
                  : _vm.sectionNavSelected == "logs"
                  ? _c(
                      "div",
                      {
                        staticClass: "list-logs hide-scrollbar",
                        class: { "no-scroll": !_vm.expandedSectionNav }
                      },
                      [_vm._m(2)]
                    )
                  : _vm._e()
              ]
            )
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "author-tect-info" }, [
      _c("p", { staticClass: "name" }, [_vm._v("Vous")]),
      _c("p", { staticClass: "date" }, [_vm._v("A l'instant")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "fileComment" } }, [
      _c("i", { staticClass: "fa-regular fa-paperclip" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item" }, [
      _c("div", { staticClass: "picture" }, [
        _c("img", { attrs: { src: "https://picsum.photos/209" } })
      ]),
      _c("div", { staticClass: "info-text" }, [
        _c("p", { staticClass: "text" }, [
          _c("span", { staticClass: "name" }, [_vm._v("Bertier Clément")]),
          _vm._v(" a mit a jour le post")
        ])
      ]),
      _c("div", { staticClass: "date" }, [_c("p", [_vm._v("A l'instant")])])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }